import type { OpsRole } from '../auth/roles';

export interface ItNavLeaf {
  id: string;
  text: string;
  path?: string;
  role?: OpsRole;
  items?: ItNavLeaf[];
}

const ROLE: OpsRole = 'ItSysAdmin';

function itSection(
  id: string,
  text: string,
  sectionPath: string,
  pages: { id: string; text: string; slug: string }[]
): ItNavLeaf {
  return {
    id,
    text,
    role: ROLE,
    items: pages.map((page) => ({
      id: page.id,
      text: page.text,
      path: `/it/${sectionPath}/${page.slug}`,
      role: ROLE
    }))
  };
}

/** Information Technology side-nav subtree (folders + placeholder leaf routes). */
export const IT_NAV_ITEMS: ItNavLeaf[] = [
  itSection('it-asset-management', 'Asset Management', 'asset-management', [
    { id: 'it-asset-inventory', text: 'Asset Inventory', slug: 'asset-inventory' },
    { id: 'it-assigned-devices', text: 'Assigned Devices', slug: 'assigned-devices' },
    { id: 'it-hardware-requests', text: 'Hardware Requests', slug: 'hardware-requests' },
    { id: 'it-warranty-tracking', text: 'Warranty Tracking', slug: 'warranty-tracking' },
    { id: 'it-retired-assets', text: 'Retired Assets', slug: 'retired-assets' }
  ]),
  itSection('it-access-control', 'Access Control', 'access-control', [
    { id: 'it-user-accounts', text: 'User Accounts', slug: 'user-accounts' },
    { id: 'it-access-requests', text: 'Access Requests', slug: 'access-requests' },
    { id: 'it-roles-permissions', text: 'Roles & Permissions', slug: 'roles-permissions' },
    { id: 'it-application-access', text: 'Application Access', slug: 'application-access' },
    { id: 'it-access-reviews', text: 'Access Reviews', slug: 'access-reviews' },
    { id: 'it-access-offboarding', text: 'Offboarding', slug: 'offboarding' }
  ]),
  itSection('it-infrastructure', 'Infrastructure', 'infrastructure', [
    { id: 'it-servers', text: 'Servers', slug: 'servers' },
    { id: 'it-network', text: 'Network', slug: 'network' },
    { id: 'it-cloud-services', text: 'Cloud Services', slug: 'cloud-services' },
    { id: 'it-backups', text: 'Backups', slug: 'backups' },
    { id: 'it-dns-certificates', text: 'DNS & Certificates', slug: 'dns-certificates' },
    { id: 'it-maintenance-windows', text: 'Maintenance Windows', slug: 'maintenance-windows' }
  ]),
  itSection('it-security-operations', 'Security Operations', 'security-operations', [
    { id: 'it-security-dashboard', text: 'Security Dashboard', slug: 'security-dashboard' },
    { id: 'it-security-alerts', text: 'Security Alerts', slug: 'security-alerts' },
    { id: 'it-phishing-reports', text: 'Phishing Reports', slug: 'phishing-reports' },
    { id: 'it-device-compliance', text: 'Device Compliance', slug: 'device-compliance' },
    { id: 'it-vulnerabilities', text: 'Vulnerabilities', slug: 'vulnerabilities' },
    { id: 'it-audit-logs', text: 'Audit Logs', slug: 'audit-logs' }
  ]),
  itSection('it-systems-management', 'Systems Management', 'systems-management', [
    { id: 'it-application-directory', text: 'Application Directory', slug: 'application-directory' },
    { id: 'it-system-status', text: 'System Status', slug: 'system-status' },
    { id: 'it-system-owners', text: 'System Owners', slug: 'system-owners' },
    { id: 'it-integrations', text: 'Integrations', slug: 'integrations' },
    { id: 'it-deployments', text: 'Deployments', slug: 'deployments' },
    { id: 'it-change-requests', text: 'Change Requests', slug: 'change-requests' }
  ]),
  itSection('it-knowledge-base', 'Knowledge Base', 'knowledge-base', [
    { id: 'it-how-to-guides', text: 'How-To Guides', slug: 'how-to-guides' },
    { id: 'it-troubleshooting', text: 'Troubleshooting', slug: 'troubleshooting' },
    { id: 'it-policies-standards', text: 'Policies & Standards', slug: 'policies-standards' },
    { id: 'it-admin-runbooks', text: 'Admin Runbooks', slug: 'admin-runbooks' },
    { id: 'it-faqs', text: 'FAQs', slug: 'faqs' },
    { id: 'it-forms-templates', text: 'Forms & Templates', slug: 'forms-templates' }
  ])
];
